import React from 'react';

import { graphql, useFragment } from 'react-relay';

import { type ProductKeys } from '../../../../common/constants/product-keys';
import type { ThirdPartyConfigsBootstrap } from '../../../../common/constants/schemas/3p-config';
import type { SearchResultProps } from '../../../../common/types';
import { ErrorBoundary } from '../../../../controllers/error-boundary';
import { OAUTH_BANNER_POSITION } from '../search-result';
import { BulkConnectBanner } from '../search-result/bulk-connect-banner';
import type { searchResultCql_AtlassianSearchPage$key } from './__generated__/searchResultCql_AtlassianSearchPage.graphql';
import { ConfluenceSearchResponse } from './confluence-search-response';

export type SearchResultCQLProps = SearchResultProps<searchResultCql_AtlassianSearchPage$key> & {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProducts: ProductKeys[];
};

export const SearchResultCQL = ({
	node,
	position,
	cloudId,
	thirdPartyConfigs,
	availableProducts,
	selectedProduct,
	searchQuery,
	searchSessionId,
	primaryProduct,
	primarySubProduct,
	appMode,
	mainContentWidth,
}: SearchResultCQLProps): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment searchResultCql_AtlassianSearchPage on ConfluenceSearchResponse {
				...confluenceSearchResponse_AtlassianSearchPage
			}
		`,
		node,
	);

	return (
		<>
			{position === OAUTH_BANNER_POSITION && (
				<BulkConnectBanner
					availableProducts={availableProducts}
					selectedProduct={selectedProduct}
					thirdPartyConfigs={thirdPartyConfigs}
				/>
			)}
			<ErrorBoundary section="SearchPageResultRecordCQL">
				<ConfluenceSearchResponse
					appMode={appMode}
					cloudId={cloudId}
					mainContentWidth={mainContentWidth}
					node={data}
					position={position}
					primaryProduct={primaryProduct}
					primarySubProduct={primarySubProduct}
					searchQuery={searchQuery}
					searchSessionId={searchSessionId}
					selectedProduct={selectedProduct}
				/>
			</ErrorBoundary>
		</>
	);
};
